import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@bwoty-web/styleguide';
import FilterGroup from './FilterGroup';
import styles from './FilterTripType.scss';

export const FilterTripType = (props) => {
  const { header, tripTypes, selected, onFilter } = props;

  const updateFilter = useCallback(
    (event) => {
      const { target } = event;

      if (target) {
        const { dataset, checked } = target;

        if (dataset.triptype) {
          onFilter('triptype', { code: dataset.triptype, value: checked });
        }
      }
    },
    [onFilter],
  );

  return (
    <FilterGroup header={header}>
      <ul className={styles.root} data-test="lms-filter-travel-group">
        {tripTypes.map((tripType) => (
          <li className={styles.item} key={tripType.key}>
            <Checkbox
              onChange={updateFilter}
              uniqueId={`lms-tf-${tripType.key}`}
              data-triptype={tripType.key}
              disabled={!tripType.count && selected.indexOf(tripType.key) === -1}
              checked={selected.indexOf(tripType.key) > -1}
            >
              {tripType.label} ({tripType.count || 0})
            </Checkbox>
          </li>
        ))}
      </ul>
    </FilterGroup>
  );
};

FilterTripType.propTypes = {
  header: PropTypes.node,
  onFilter: PropTypes.func,
  selected: PropTypes.arrayOf(PropTypes.string),
  tripTypes: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      label: PropTypes.node,
      count: PropTypes.number,
    }),
  ),
};
